var recert_state = false;

function usercenter() {
  //var api_url = 'https://api.pencilnews.cn';
  var token = $.jStorage.get("localToken");
  if ($.jStorage.get("localToken")) {
  } else {
    var indexUrl = "/";
    if (IsPC()) {
      location.href = indexUrl;
      console.log("PC");
    } else {
      indexUrl = "/login_phone";
      $.jStorage.set("localLastUrl", location.href);
      location.href = indexUrl;
      console.log("手机");
    }
  }
  $.jStorage.set("isUsercenter", "on");
  //    showSubscribeStatus();

  /* 点击前往付费页面 */
  $("#openVip,#renewVip").on("click", function(e) {
    e.preventDefault();
    window.location.href = Pc_Url + "buy";
  });

  /* 预览图片 */
  UTL.previewImg("img.js-previewImg"); 

  //验证数据能否通过验证
  function validAllCertData(certValidData) {
    return (
      certValidData.name &&
      certValidData.email &&
      certValidData.company &&
      certValidData.job &&
      certValidData.identity &&
      !!certValidData.hash
    );
  }

  function showValidNotPass(certValidData) {
    var href = location.pathname + location.search;
    var validFailedHref = href;
    if (!certValidData.name) {
      $("#cre-myName")
        .parent()
        .addClass("checked_failed_input");
      validFailedHref = href + "#certified-form";
      showWarning("真实姓名不能为空！");
      return;
    } else if (!certValidData.identity) {
      // $("#cre-myName")
      //   .parent()
      //   .addClass("checked_failed_input");
      // validFailedHref = href + "#certified-form";
      showWarning("请选择您想要认证的身份类型！");
      return;
    } else if (!certValidData.company) {
      $("#cre-institution")
        .parent()
        .addClass("checked_failed_input");
      validFailedHref = href + "#cre-myName";
      showWarning("所在机构信息不能为空！");
      return;
    } else if (!certValidData.job) {
      $("#cre-job")
        .parent()
        .addClass("checked_failed_input");
      validFailedHref = href + "#cre-institution";
      showWarning("公司职位信息不能为空！");
      return;
    } else if (!certValidData.email) {
      $("#cre-myEmail")
        .parent()
        .addClass("checked_failed_input");
      validFailedHref = href + "#cre-job";
      showWarning("邮箱不能为空！");
      return;
    } else if (!certValidData.hash) {
      $(".file").addClass("checked_failed_input");
      validFailedHref = href + "#cre-myEmail";
      showWarning("名片照片不能为空！");
      return;
    } else {
    }
    // ==============
    if (certValidData.hash) {
      $(".file").removeClass("checked_failed_input");
    }
    if (certValidData.email) {
      $("#cre-myEmail")
        .parent()
        .removeClass("checked_failed_input");
    }
    if (certValidData.job) {
      $("#cre-job")
        .parent()
        .removeClass("checked_failed_input");
    }
    if (certValidData.company) {
      $("#cre-institution")
        .parent()
        .removeClass("checked_failed_input");
    }
    if (certValidData.name) {
      $("#cre-myName")
        .parent()
        .removeClass("checked_failed_input");
    }
    // if (!certValidData.wechat) {
    //     $("#cert_realwechat").addClass("checked_failed_input");
    //     showCheckedFailedIcon("cert_realwechat_check");
    //     //            validFailedHref = href + "#cert_realwechat";
    //     validFailedHref = href + "#cert_realname";
    // }

    if (!validAllCertData(certValidData)) {
      location.href = validFailedHref;
    }
  }

  //验证姓名
  $("#cre-myName").on("keyup focusout", function() {
    var name = $("#cre-myName").val();
    if (validIsHasNumber(name) || name == "" || name.length < 2) {
      $("#cre-myName")
        .next()
        .attr("src", "/imgs/pay/pay_detail/no.png");
      _certValidData.name = false;
    } else {
      $("#cre-myName")
        .next()
        .attr("src", "/imgs/pay/pay_detail/yes.png");
      _certValidData.name = true;
    }
  });


  //验证微信号
  // $("#cert_realwechat").on('keyup focusout', function() {
  //     var wechat = $("#cert_realwechat").val();
  //     if (wechat == 0) {
  //         showCheckedFailedIcon("cert_realwechat_check");
  //         _certValidData.wechat = false;
  //     } else {
  //         showCheckedPassedIcon("cert_realwechat_check");
  //         $("#cert_realwechat").removeClass("checked_failed_input");
  //         _certValidData.wechat = true;
  //     }
  // });

  //验证公司
  $("#cre-institution").on("keyup focusout", function() {
    var company = $("#cre-institution").val();
    if (company == 0) {
      $("#cre-institution")
        .next()
        .attr("src", "/imgs/pay/pay_detail/no.png");
      _certValidData.company = false;
    } else {
      $("#cre-institution")
        .next()
        .attr("src", "/imgs/pay/pay_detail/yes.png");
      _certValidData.company = true;
    }
  });

  //验证职位
  $("#cre-job").on("keyup focusout", function() {
    var job = $("#cre-job").val();
    if (job == 0) {
      $("#cre-job")
        .next()
        .attr("src", "/imgs/pay/pay_detail/no.png");
      _certValidData.job = false;
    } else {
      $("#cre-job")
        .next()
        .attr("src", "/imgs/pay/pay_detail/yes.png");
      _certValidData.job = true;
    }
  });

  //验证邮箱
  $("#cre-myEmail").on("keyup focusout", function() {
    var email = $("#cre-myEmail").val();
    if (!validIsEmail(email)) {
      $("#cre-myEmail")
        .next()
        .attr("src", "/imgs/pay/pay_detail/no.png");
      _certValidData.email = false;
    } else {
      $("#cre-myEmail")
        .next()
        .attr("src", "/imgs/pay/pay_detail/yes.png");
      _certValidData.email = true;
    }
  });
  // 上传名片
  $(".certified_form .file .card_file input[type='file']").change(function() {
    var imgSrc;
    var selectId = $(this).attr("id");
    var f = document.getElementById(selectId).files[0];
    if (f.size > 1024 * 1024 * 2) {
      showWarning("图片大小不得超过2M！");
      return;
    }
    imgSrc = window.URL.createObjectURL(f);
    $(".certified_form .file .card_file #upload_preview").attr("src", imgSrc);
    $(".certified_form .file .card_file #upload_preview").show();
    $("#card-preview").removeClass("checked_failed_input");
    getBase64(
      $(".certified_form .file .card_file #upload_preview")[0],
      function(data_cropedImgBase64) {
        uploadAvatar(
          ".card_file",
          data_cropedImgBase64,
          {
            uptype: "4",
            ext: "jpg"
          },
          putb64Jq
        );
      }
    );
  });
  //提交
  $("#btn_next3").click(function(e) {
    e.preventDefault();

   
    var certData = {
      email: "",
      name: "",
      com: "",
      job: "",
      card: "",
      hash: "",
      identity: ""
    };
    certData.name = $("#cre-myName").val();
    certData.email = $("#cre-myEmail").val();
    certData.com = $("#cre-institution").val();
    certData.job = $("#cre-job").val();
    certData.card = $("#upload_preview").attr("data-id");
    certData.hash = $("#upload_preview").attr("data-hash");
    certData.identity = $("#certIdentity_select").children('option:selected').attr("identity_id");
    if(certData.name != '') {
      _certValidData.name = true
    }
    if(certData.email != '') {
      _certValidData.email = true
    }
    if(certData.com != '') {
      _certValidData.company = true
    }
    if(certData.job != '') {
      _certValidData.job = true
    }
    if(certData.card != '') {
      _certValidData.hash = true
    }
    if(certData.identity != '') {
      _certValidData.identity = true
    }
    
    //验证，如果不通过，加红色框
    showValidNotPass(_certValidData);
    // console.log("certData:", certData)
    //验证，如果不通过，返回，不能提交
    if (!validAllCertData(_certValidData)) {
      return;
    }
    showLoadingGif();
    $.ajax({
      url: v1url + "user/update-auth",
      type: "POST",
      headers: {
        token: token,
        devicetoken: cookie_PENCILNEWSID
      },
      data: certData,
      success: function(data) {
        if (data.code == -1) {
          reLoginOnUc();
          return;
        }
        if (data.code == 1000) {
          showSuccess("认证信息提交成功！");
          UCA.getuserdata(data, cities);
          $("#certified-form").hide();
          $("#showCerTitle").hide();
          $("#basic-info-edit,#certified").show();
          document.documentElement.scrollTop = document.body.scrollTop = 0;
          // $("#certified").show().siblings().hide();
        } else {
          showWarning(data.message);
        }
        closeLoadingGif();
      }
    });
  });

  $("#basic-info button").click(function() {
    // $(".flag").hide();
    // $("#basic-info-edit").addClass("flag");
    $("#basic-info").hide();
    $("#basic-info-edit").show();
  });

  $(".favorite_delete").click(function() {
    token = $.jStorage.get("localToken");
    var $this = $(this)
      .parent()
      .parent()
      .parent();
    $.ajax({
      url:
        v1url +
        "/favorites/remove?" +
        jQuery.param({
          article_id: article_id
        }),
      type: "DELETE",
      headers: {
        token: token,
        devicetoken: cookie_PENCILNEWSID
      },
      success: function(data) {
        if (data.code == -1) {
          reLoginOnUc();
          return;
        }
        $this.hide();
      }
    });
  });

}


$("#card-preview").click(function() {
  //上传
  $("#my_cer2 .moxie-shim input").click();

});



//点击左边tab加上url
$(".uc-left-sidebar .tab-item a").click(function() {
  window.history.pushState(
    null,
    null,
    "/usercenter?cate=" +
      $(this)
        .attr("href")
        .split("#")[1]
  );
  // console.log($(this).parent().eq())
});

//加载页面时根据url显示不同tabcontent
function checkUrlUc() {
  var ucCate = UTL.getUrlParam("cate"),
    ucState = UTL.getUrlParam("state");

  if (!IsPC()) {
    if (UTL.getUrlParam("contactid")) {
      location.href = "/m_contactdetail" + location.search;
    } else {
      // location.href = "/m_usercenter";
    }
  }
  if (ucCate) {
    if (ucCate == "my-certification") {
      //这儿要另外绑定事件，之前的事件在回调函数里面
      // $("#liCertification a").click();
    } else {
      for (
        var i = 0, len = $(".uc-left-sidebar .tab-item a").length; i < len; i++
      ) {
        if (
          $(".uc-left-sidebar .tab-item a")
          .eq(i)
          .attr("href")
          .split("#")[1] == ucCate
        ) {
          // console.log(i)
          $(".uc-left-sidebar .tab-item a")
            .eq(i)
            .click();
          break;
        }
      }
    }
  } else {
    // $("#liContact").click();
  }
}

//右边高度

(function() {
  var leftHeight = $(".uc-left-sidebar").height();
  // console.log(leftHeight);
  $(".right-con").css("minHeight", leftHeight);
})();

/* 从邮箱链接跳转的url相关 */

//判断是否登录
function isHasLogin() {
  if ($.jStorage.get("localToken")) {
    return true;
  }
  return false;
}

//根据contactid显示弹窗

//浏览器关闭注销临时token
function removeTempToken() {
  if ($.jStorage.get("localCacheToken")) {
    logout();
  }
}

//根据临时token登录并获取登录信息
function loginByTempToken(localCacheToken, fun) {
  $.post({
    url: v1url + "contact/token",
    headers: {
      devicetoken: cookie_PENCILNEWSID
    },
    data: {
      contact_token: localCacheToken
    },
    success: function(data) {
      if (typeof data == "string") {
        data = $.parseJSON(data);
      }

      if (data.code == -1) {
        reLoginOnUc();
        return;
      }

      if (data.code == 1000) {
        if (!isHasLogin()) {
          //                    console.log("aaaaaaa");
          //                    console.log(data);
          fun(localCacheToken, data);
        }
      } else {
        promptAndJumpIndex();
      }
    },
    error: function(data) {}
  });
}

function putTempTokenCache(localCacheToken, data) {
  if (data["code"] == -3) {
  } else if (data["code"] == 1000) {
    //console.log("putTempTokenCache" + data.code);
    $("#login_bg").hide();
    $(".login_sigin_con").hide();
    $("#login_on1").show();
    var imgAvatarSrc = "/imgs/defaultAva40.png",
      imgAvatarUrl = "https://cdn.pencilnews.cn/";
    if (data.data.user.profile.avatar) {
      imgAvatarSrc = imgAvatarUrl + data.data.user.profile.avatar;
    }
    $("#show_personal img").attr("src", imgAvatarSrc);
    var tempToken = data["data"]["user"]["token"];
    var tempTokenExpired = 43200000;
    var tempUsername = data["data"]["user"]["profile"]["username"];
    var tempSubscribe = data["data"]["user"]["profile"]["subscribed"];
    var tempEmail = data["data"]["user"]["profile"]["email"];
    var tempUid = data["data"]["user"]["uid"];
    var tempName = data["data"]["user"]["profile"]["name"];
    if (tempName == "") {
      tempName = tempUsername;
    }
    var tempWechat = data["data"]["user"]["profile"]["wechat"];
    if (tempWechat == "") {
      tempWechat = "";
    }
    var tempRoleId = data["data"]["user"]["profile"]["role"]["role_id"];
    var tempAvatar = data["data"]["user"]["profile"]["avatar"];
    var tempPhone = data["data"]["user"]["profile"]["phone"];
    $.jStorage.set("localCacheToken", localCacheToken);
    $.jStorage.set("localToken", tempToken);
    $.jStorage.set("localUsername", tempUsername);
    $.jStorage.set("localSubscribe", tempSubscribe);
    $.jStorage.set("localEmail", tempEmail);
    $.jStorage.set("localUid", tempUid);
    $.jStorage.set("localName", tempName);
    $.jStorage.set("localRoleId", tempRoleId);
    $.jStorage.set("tempAvatar", tempAvatar);
    $.jStorage.set("tempPhone", tempPhone);
    $.jStorage.set("tempImgAvatarUrl", imgAvatarSrc);
    $.jStorage.set("localWechat", tempWechat);

    saveUser({
      uid: tempUid,
      username: username,
      name: tempName,
      phone: tempPhone,
      email: tempEmail,
      token: tempToken,
      subscribed: tempSubscribe,
      avatar: tempAvatar
    });
  } else {
    showWarning(data["message"]);
  }
}

//临时token无效，提示连接失效，跳转到首页
function promptAndJumpIndex() {
  showWarning("链接已经失效，请登录进入个人中心查看");
  //    if($.jStorage.get("localToken")){
  //        var indexUrl = "/usercenter";
  //        window.location.href = indexUrl
  //    }else{
  //        setTimeout(function(){
  //            var indexUrl = "/";
  //            window.location.href = indexUrl;
  //        },2000)
  //    }
}

//邮件跳转主函数
function jumpFromMailUrl() {
  var contactid = "";
  var localCacheToken = "";
  //console.log("jump");
  if (UTL.getUrlParam("contactid") != null) {
    contactid = UTL.getUrlParam("contactid");
  }
  if (UTL.getUrlParam("contact_token") != null) {
    localCacheToken = UTL.getUrlParam("contact_token");
  }
  if (contactid != "" && localCacheToken != "") {
    //使用token登录，if token失效，提示连接失效
    //如果已经登录，跳转个人中心主页，如果没登录，提示登录，2秒后跳到主页
    if (isHasLogin()) {
      usercenter();
      checkUrlUc();
      ucAjax();
      // $("#liContact").trigger("click");
      // $("a[href$='contact-my']").trigger("click");
    } else {
      loginByTempToken(localCacheToken, function(localCacheToken, data) {
        //console.log("localcache" + localCacheToken);
        //console.log("logindata" + data);
        putTempTokenCache(localCacheToken, data);
        usercenter();
        checkUrlUc();
        ucAjax();
        // $("#liContact").trigger("click");
        // $("a[href$='contact-my']").trigger("click");
      });
    }

    //根据contactId显示弹窗
  } else {
    usercenter();
    checkUrlUc();
    ucAjax();
    if (contactid != "") {
      // $("#liContact").trigger("click");
      // $("a[href$='contact-my']").trigger("click");
    }
  }

  //    if(contactid != ""){
  //        $('#liContact').trigger("click");
  //        $("a[href$='contact-my']").trigger("click");
  //    }
}

//点击按钮进行从新认证
$("#cer_again").click(function() {
  $("#cer_wait").hide();
  $("#cer_success").hide();
  $("#cer_failure").hide();
  $("#my_cer2").show();
});

/* 从邮箱链接跳转的url相关 end */

/* 账号安全修改密码 */

$("#safe-changepw-btn").click(function() {
  $("#item-changepw").addClass("hide");
  $("#account-changepw-box").removeClass("hide");
});

$("a[href='#safe-information'],a[href='#bind-account']").click(function() {
  $("#account-changepw-box").addClass("hide");
  $("#item-changepw").removeClass("hide");
});

var _countTimer = "";

$("#changepw-codeBtn").click(function() {
  var phone = $("#changepw-phone").val();
  if (validPhone($("#changepw-phone"))) {
    showLoadingGif();
    $("#changepw-codeBtn").attr("disabled", "true");
    getChangePwCode(phone, function(data) {
      closeLoadingGif();
      if (data.code == 1000) {
        var obj = $("#changepw-codeBtn");
        obj.attr("disabled", "true");
        var count = data.data.time_last || 60;
        _countTimer = setInterval(function() {
          count--;
          obj.html(count);
          if (count == 0) {
            clearInterval(_countTimer);
            obj.removeAttr("disabled");
            obj.html("获取验证码");
          }
        }, 1000);
      } else {
        $("#changepw-codeBtn").removeAttr("disabled");
      }
    });
  }
});

$("#changepw-submitBtn").click(function() {
  var code = $("#changepw-code").val(),
    phone = $("#changepw-phone").val(),
    password = $("#changepw-newpw").val();

  if (!validPhone($("#changepw-phone"))) {
    return;
  } else if (!validCode(code)) {
    return;
  } else if (!validChangepw(password)) {
    return;
  }

  var changepwData = {
    phone: phone,
    code: code,
    password: password
  };

  showLoadingGif();
  $("#changepw-submitBtn").attr("disabled", "true");
  changePw(changepwData, function(data) {
    $("#changepw-submitBtn").removeAttr("disabled");
    if (data.code == 1000) {
      $("#changepw-code").val(""),
        $("#changepw-phone").val(""),
        $("#changepw-newpw").val("");
      $("#account-changepw-box").addClass("hide");
      $("#item-changepw").removeClass("hide");
      clearInterval(_countTimer);
      $("#changepw-codeBtn").removeAttr("disabled");
      $("#changepw-codeBtn").html("获取验证码");
    }
  });
});

function validChangepw(password) {
  if (password.length >= 6) {
    return true;
  } else {
    showWarning("密码长度不能小于6位！");
    return false;
  }
}

//获取验证码
function getChangePwCode(phone, fun) {
  var queryData = {
    sms_type: "forgot",
    phone: phone
  };
  var encryptData = encryptRequest(queryData);
  var $headerData = $.extend(
    {},
    {
      devicetoken: cookie_PENCILNEWSID
    },
    encryptData
  );
  $.post({
    url: v1url + "sms/send?verify=regverify",
    headers: $headerData,
    data: queryData,
    dataType: "json",
    success: function(data) {
      fun && fun(data);
      if (data.code == 1000) {
        showSuccess(
          "验证码发送成功，" + data.data.time_last + "秒后方可再次获取"
        );
      } else {
        showWarning(data.message);
      }
    },
    error: function() {}
  });
}

//验证码必须为数字
function validCode(str) {
  var reg = /\d{6}/;
  if (reg.test(str) && str.trim() !== "") {
    return true;
  } else {
    showWarning("验证码为6位数字！");
    return false;
  }
}

//修改密码
function changePw(data, fun) {
  $.ajax({
    type: "PUT",
    url: v1url + "user/forgot/",
    headers: {
      devicetoken: cookie_PENCILNEWSID
    },
    data: data,
    dataType: "json",
    success: function(data) {
      closeLoadingGif();
      fun(data);
      if (data["code"] == 1000) {
        showSuccess("修改密码成功");
      } else {
        showWarning(data.message);
      }
    },
    error: function() {}
  });
}

/* 账号安全修改密码 end */

function getBase64(img, cb) {
  showLoadingGif();
  // 图片文件转base64
  var dataURL = "";
  img.onload = function() {
    //要先确保图片完整获取到，这是个异步事件
    var canvas = document.createElement("canvas"), //创建canvas元素
      imgSize = UTL.getImgSize(img); //确保canvas的尺寸和图片一样
    canvas.width = imgSize.width;
    canvas.height = imgSize.height;
    canvas.getContext("2d").drawImage(img, 0, 0, imgSize.width, imgSize.height); //将图片绘制到canvas中
    dataURL = canvas.toDataURL(); //转换图片为dataURL
    dataURL = dataURL.split("base64,")[1];
    cb && cb(dataURL);
  };
}

function uploadAvatar(key, cropedImgBase64, datas, cb) {
  var uptoken3, upkey3;
  //Fsize: 文件大小，必选。支持传入 -1 表示文件大小以 http request body 为准。
  var url3 = "https://up-z1.qbox.me/putb64/-1";
  $.ajax({
    url: v1url + "uploader/uptoken",
    type: "GET",
    data: datas,
    headers: {
      token: $.jStorage.get("localToken"),
      devicetoken: cookie_PENCILNEWSID
    },
    success: function(data) {
      if (data.code == -1) {
        reLoginOnUc();
        return;
      } else if (data.code == 1000) {
        uptoken3 = data.data.uptoken;
        uptoken3 = "UpToken " + uptoken3;
        upkey3 = data.data.key;
        url3 += "/key/" + BASE64.encoder(upkey3);
        if (cropedImgBase64 != undefined) {
          cb && cb(key, cropedImgBase64, url3, uptoken3);
        }
      } else {
        showWarning(data.message);
      }
    }
  });
}

function putb64Jq(key, mypic, myurl, mytoken) {
  $.ajax({
    url: myurl,
    type: "POST",
    headers: {
      "Content-Type": "application/octet-stream",
      Authorization: mytoken,
      devicetoken: cookie_PENCILNEWSID
    },
    data: mypic,
    success: function(data) {
      $(key + " #upload_preview").attr("data-id", data.key);
      $(key + " #upload_preview").attr("data-hash", data.hash);
      _certValidData.hash = true;
      closeLoadingGif();
    }
  });
}
